function normalizeIdentityValue(value) {
  if (value === null || value === undefined) {
    return ''
  }

  if (typeof value === 'string') {
    return value.trim()
  }

  if (typeof value === 'number') {
    return String(value)
  }

  return ''
}

export function getUserSignInId(profileData) {
  const candidateValues = [
    profileData?.userName,
    profileData?.username,
    profileData?.loginId,
    profileData?.primaryContact,
    profileData?.email,
    profileData?.emailId,
    profileData?.mobile,
    profileData?.phoneNumber,
    profileData?.communicationPref?.voiceCall?.uid,
    profileData?.info?.userName,
    profileData?.info?.username,
    profileData?.info?.email,
  ]

  return candidateValues.map(normalizeIdentityValue).find(Boolean) || ''
}
